module.exports = __webpack_public_path__ + "img/salad.dd6ac8f8.png";